import React, { Suspense } from "react";
import { HashRouter, Route, Routes } from "react-router-dom";
import AppLayout from "layouts/App.layout";
import MainPage from "pages/Main.page";
import AboutUsPage from "pages/AboutUs.page";
import ProductsPage from "pages/Products.page";
import SingleProductPage from "pages/SingleProduct.page";

function App() {
	return (
		<Suspense fallback={""}>
		<HashRouter>
			<Routes>
				<Route element={ <AppLayout/> }>
					<Route path="/" element={ <MainPage/> }/>
					<Route path="/about-us" element={ <AboutUsPage/> }/>
					<Route path="/products" element={ <ProductsPage/> }/>
					<Route path="/products/:productId" element={ <SingleProductPage/> }/>
				</Route>
			</Routes>
		</HashRouter>
		</Suspense>
	)
}

export default App;